import React, { useEffect, useState } from "react";
import { createUseStyles } from "react-jss";
import { pxToRem } from "@/util/common";
import FixedNavBar from "@/components/fixedNavBar";
import { Image, InfiniteScroll, PullToRefresh, SearchBar } from "antd-mobile";
import InfiniteScrollContent from "@/components/InfiniteScrollContent";
import CustomEmpty from "@/components/Empty";
import { useAgentOtherMember } from "@/hooks/useOrderRecords";
import useCustomTranslation from "@/hooks/useTranslation";
import { getUserInfoMethod } from "@/redux/reducers/authSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "@/redux/store";
import OtherTinyChen from "@/components/tinyChen/other";

const OtherMember: React.FC = () => {
	const classes = useStyles();
	const dispatch: AppDispatch = useDispatch();
	const { t } = useCustomTranslation();
	// 先驱者用着
	const [firstPage, setFirstPage] = useState(true);
	// sort/默认根据创建时间倒序
	const [bySortValue, setBySortValue] = useState(0);
	const [value, setValue] = useState("");

	const bySortList = [
		{
			sort: 0,
			name: "SortByTime",
			profit: "DaysTotalProfit",
		},
	];
	const { membersData, hasMore, handleRefresh, handleFetchMore } =
		useAgentOtherMember({
			sort: bySortList[bySortValue].sort,
			recordNickname: value,
		});

	useEffect(() => {
		if (!firstPage) handleRefresh();
		setFirstPage(false);
	}, [bySortValue]);

	useEffect(() => {
		dispatch(getUserInfoMethod());
	}, []);

	return (
		<div className="router-main">
			<FixedNavBar title={t("OtherMember")} />
			<div className="router-view">
				<PullToRefresh
					onRefresh={handleRefresh}
					canReleaseText={t("canReleaseText")}
					completeText={t("completeText")}
					pullingText={t("pullingText")}
					refreshingText={t("refreshingText")}
				>
					<div className={classes.MembersWrap}>
						<div className={classes.searchFor}>
							<SearchBar
								value={value}
								placeholder={`${t("Search")} ${t("Members")}`}
								style={{
									width: "100%",
									fontSize: pxToRem(12),
									fontWeight: "400",
									color: "#76819F",
									"--border-radius": pxToRem(40),
									"--height": pxToRem(36),
									"--background": "#181B24",
									"--placeholder-color": "#868FA8",
								}}
								icon={
									<Image
										src={require("@/assets/images/icons/search.png")}
										width={22}
										height={22}
									/>
								}
								onChange={(val: string) => {
									setValue(val);
								}}
								onSearch={() => handleRefresh()}
							/>
						</div>
						{membersData.length === 0 ? (
							<CustomEmpty />
						) : (
							<OtherTinyChen data={membersData} />
						)}
						{membersData.length > 0 && (
							<InfiniteScroll
								loadMore={handleFetchMore}
								hasMore={hasMore}
							>
								<InfiniteScrollContent hasMore={hasMore} />
							</InfiniteScroll>
						)}
					</div>
				</PullToRefresh>
			</div>
		</div>
	);
};

export default OtherMember;

const useStyles = createUseStyles({
	MembersWrap: {
		display: "flex",
		flexDirection: "column",
		padding: {
			left: pxToRem(20),
			right: pxToRem(20),
			bottom: pxToRem(30),
		},
	},
	searchFor: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		margin: {
			top: pxToRem(8),
			bottom: pxToRem(8),
		},
		borderRadius: pxToRem(40),
		border: "1px solid #3A375D",
		"--adm-color-background": "#181B24",
		"& .adm-input-element": {
			"--color": "#FFFFFF",
		},
	},
});
